export default __webpack_public_path__ + "static/media/grasp.57de5b44.png";